//=============================================================================
// Contents   : HRDB
//              一覧テンプレート
//              GetListTemp
// Author     : RV光永 
// LastUpdate : 2022/12/1
// Since      : 2022/11/31
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  

/* ====== React ====== */
import React,{ useEffect, useState } from "react";
import { useForm,useWatch } from "react-hook-form";
import { useLocation, useNavigate } from 'react-router-dom';
// import { useProvideData } from "03CommonApiParts/use-context";

/* ====== CSS ====== */

/* ====== Image ====== */

/* ====== Component Js/Jsx ====== */
import { Table } from "02CommonUiParts/TableParts/Table";
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";
// import { assets } from "03CommonApiParts/Configuration";
import { Title } from "01Pages/Common/UiParts/Title";
import { SearchField } from "02CommonUiParts/OtherParts/SearchField";
/* ====== Style ====== */
import { StyleCommon } from "01Pages/Common/Style/StyleCommon";
import { Underbar } from "02CommonUiParts/OtherParts/Underbar";
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { Dialog } from "02CommonUiParts/MessageParts/Dialog";
import { useProvideData } from "03CommonApiParts/use-context";
import { CFArrayFount, CFJsonIgnore,CFStringDecodeJP,CFStringEncodeJP, CFUTCToDateInputFormatEdit, checkChangeFlag, confirmChange } from "03CommonApiParts/CommonFunction";
import { CreateExcel } from "03CommonApiParts/CreateExcel";
import { CODEDIFINITION_STORAGE, screenMaster, SEARCH_STORAGE, USERINFO_STORAGE } from "03CommonApiParts/CodeDefinition";
import { screenDisplayMessage } from "03CommonApiParts/MessageList";
/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  
// const SdivBulkUpdateWrapper = styled.div`
//     margin: 10px 0;
// `
/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  
const CommonStyle =  StyleCommon();//共通スタイルドコンポーネント
const base64Swicth = true;	//エンコード処理スイッチ

/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */  

/* ========= 一覧テンプレート ========= */
export const GetListTemp = (props) => {
    const {apiPath, updateApiPath, defaultSearch, listType, searchCount, pageTitle, searchContentsLeft, searchContentsRight, getConfig, updateConfig, headData, bodyData, editBodyData,onClickBodyRow, backButton, path, editHeadData, masterList, disableSelectBox} = props;
    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    const navigate = useNavigate();//画面遷移用
    const location = useLocation();
    const apiData = useProvideData();//APIデータ取得
    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */

    /* ====== sessionStorageからの情報を定義 ====== */ 
    /* CODEDIFINITION_STORAGEからコード定義を取得 */
    const codeDefinitionStorage = sessionStorage.getItem(CODEDIFINITION_STORAGE);//sessionStorageからコードマスタを取得
    const codeDefinitionValue = JSON.parse(codeDefinitionStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const screenIdList = CFArrayFount(codeDefinitionValue,'code','screenId').list; //画面IDのリストを取得
    /* USERINFO_STORAGEから従業員情報を取得 */
    const userInfoStorage = sessionStorage.getItem(USERINFO_STORAGE);
    var userInfoValue = JSON.parse(userInfoStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const userName = userInfoValue.empJpnSrname + ' ' + userInfoValue.empJpnName;//名前
    const screenId = CFArrayFount(screenMaster,'path',location.pathname).id;//画面Id
    /* ====== localStorageからの情報を定義 ====== */ 
     /* SEARCH_STORAGEからコード定義を取得 */
    const searchToken = localStorage.getItem(SEARCH_STORAGE);//localStorageから検索キー項目を取得
    var searchValue = JSON.parse(searchToken);//ローカルストレージから検索項目を取得

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 

    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */

    const [loading, setLoading] = useState(false); //画面表示用
    const [progress, setProgress] = useState(false); //プログレスバー表示用
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });
    const [dialogMessage, setDialogMessage] = useState({ //ダイアログ表示用
        open:false,
    });
    const [dataRow, setDataRow] = useState([]);//データ格納用
    const [displayData, setDisplayData] = useState();//データ絞り込み表示用
    const [confirm, setConfirm] = useState({});//確認用データ格納用
    const [newData, setNewData] = useState([]);//変更後データ格納用
    const [master, setMaster] = useState();//マスターデータ格納用
    // セッションストレージのコードマスタ情報
    // ※useEffect内で無限ループを防ぐため、ステートに格納する


    const [bodyDataNew, setBodyDataNew] = useState(); //body設定
    const [editBodyDataNew, setEditBodyDataNew] = useState(); //editBody設定
    const [pageMode, setPageMode] = useState('list');

    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */
    /* ====== hookformを定義 ====== */ 
    const { register, getValues,setValue, handleSubmit,watch,reset,control,formState: { errors } } = useForm({
            mode: 'onBlur',
            reValidateMode: 'onChange',
            shouldUseNativeValidation: false,
            shouldUnregister: false,
            escalationCode:false,
            defaultValues:{
                search:searchValue?.[screenId] ?
                (Object.keys(searchValue?.[screenId]).some(key=>searchValue?.[screenId][key] !== undefined) ? searchValue[screenId] : defaultSearch)
                :defaultSearch,
                payload:dataRow
            }
        });
    /* ====== useWatchを定義 ====== */ 
    useWatch({control, name: 'payload'});


    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */

    /* ====== マスターデータを元にbodyDataを表示 ====== */ 
    const createBodyData = (masterData) =>{
        /* マスタデータがある場合 */
        if(masterList){
            const bodyDataNewList = [];
            bodyData.forEach((body) =>{
                const object = {...body};
                if(body.masterType === 'master'){

                    object.master = CFArrayFount(masterData,'code',body.master);

                }else if(body.masterType === 'codeMaster'){
                    object.master = CFArrayFount(codeDefinitionValue,'code',body.master);

                }
                bodyDataNewList.push(object);
            })
            setBodyDataNew(bodyDataNewList);

            const editBodyDataNewList = [];
            editBodyData?.forEach((body) =>{
                const object = {...body};
                if(body.masterType === 'master'){

                    object.master = CFArrayFount(masterData,'code',body.master);

                }else if(body.masterType === 'codeMaster'){

                    object.master = CFArrayFount(codeDefinitionValue,'code',body.master);
                    
                };
                editBodyDataNewList.push(object);
            });
            setEditBodyDataNew(editBodyDataNewList);

        /* コード定義のみの場合 */
        }else{
            const bodyDataNewList = [];
            bodyData.forEach((body) =>{
                const object = {...body};
                if(body.masterType === 'codeMaster'){
                    object.master = CFArrayFount(codeDefinitionValue,'code',body.master);
                };
                bodyDataNewList.push(object);
            })
            setBodyDataNew(bodyDataNewList);

            const editBodyDataNewList = [];
            editBodyData?.forEach((body) =>{
                const object = {...body};
                if(body.masterType === 'codeMaster'){
                    object.master = CFArrayFount(codeDefinitionValue,'code',body.master);
                };
                editBodyDataNewList.push(object);
            });
            setEditBodyDataNew(editBodyDataNewList);
        };
    }
    /* ====== マスタの取得処理 ====== */
    const getMaster = async(date,list) => {

        /* リクエスト先 */
        const apiPath = '/search/getmaster';
        /* リクエスト*/
        const handlingInformation = {};
        const key = {};

        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail;
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';

        /* キー */
        key.aplySrtDate = date;
        key.mstList = list;

        /* リクエストパラメータ */
        const apiBody = {handlingInformation:handlingInformation, key:key};

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* APIリクエスト結果を判定 */
            if(result.isSuccessed){//APIリクエスト結果 = 正常
                const data = result.responseData.data.payload;
                const masterList = [];
                data.forEach((item)=>{
                    const masterSmallList = [];
                    item.list.forEach((master)=>{
                        masterSmallList.push({
                            value:master.value,
                            label:CFStringDecodeJP(master.label,base64Swicth)
                        });
                    });
                    masterList.push({
                        code:item.code,
                        name:item.name,
                        list:masterSmallList
                    })
                });
                createBodyData(masterList);
                setMaster(masterList);
                getData();

            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
            }

        });
    };
    /* ====== 検索ボタンを押した時の処理 ====== */
    const getData = async()=>{
        /* プログレスバー表示 */
        setProgress(true);
        const handlingInformation = {
            hndEmpMailAdrs: userInfoValue.mail,
            hndEmpFullName: CFStringEncodeJP(userName,base64Swicth),
            sreId:screenId,
            hndId:'GET'
        };
        /* pathから検索キーの保存先を検索してkeyをセットする */
        const searchData = JSON.parse(JSON.stringify(getValues('search')));
        searchValue = {
            ...searchValue,
            [CFArrayFount(screenMaster,'path',location.pathname).id]:searchData
        };

        /* localStorageに検索項目保存 */
        localStorage.setItem(SEARCH_STORAGE, JSON.stringify(searchValue));

        /* 検索値の取得 */
        let key = JSON.parse(JSON.stringify(getValues('search')));
        getConfig.key.forEach((item)=>{
            if(key[item.name] === '' || key[item.name] === undefined){
                key[item.name] = null;
            }else if(item.base64){
                key[item.name] = CFStringEncodeJP(key[item.name],base64Swicth);
            }
        });

        /* リクエストパラメータ */
        const apiBody = { key: key, handlingInformation:handlingInformation };
        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* プログレスバー非表示 */
            setProgress(false);

			/* APIリクエスト結果を判定 */
            if (result.isSuccessed) {//APIリクエスト結果 = 正常

                /* APIから取得したデータを、データ編集用配列に格納 */
                const dataEdit = [];
                result.responseData.data.payload.forEach((row, index) => {
                    const dataObject = {}
                    getConfig.payload.forEach((item)=>{
                        const checkBoolean = (v) =>{
                            if(v === undefined || v === null){
                                return '';
                            }
                            else if(v === true){
                                return 'true';
                            }else if(v === false){
                                return 'false';
                            }
                            else{
                                return v;
                            }
                        };
                        if(item.name === 'chgList' && row[item.name]){//従業員一覧の変更履歴用
                            row[item.name].forEach((rowListData)=>{
                                const changeName = CFStringDecodeJP(rowListData.chgItemName,base64Swicth);
                                const beforeValue = CFStringDecodeJP(rowListData.chgBfItemCont,base64Swicth) ? CFStringDecodeJP(rowListData.chgBfItemCont,base64Swicth) : '未入力';
                                const afterValue = CFStringDecodeJP(rowListData.chgAftItemCont,base64Swicth) ? CFStringDecodeJP(rowListData.chgAftItemCont,base64Swicth) : '未入力';
                                dataObject[item.name] = dataObject[item.name] ? `${dataObject[item.name]}${changeName}:${beforeValue}→${afterValue};`: `${changeName}:${beforeValue}→${afterValue};`
                            });
                        }else{
                            if(item.name2){
                                let value1;
                                let value2;
                                if(item.base64){
                                    value1 = row[item.name] ?  CFStringDecodeJP(row[item.name],base64Swicth): '';
                                }else{
                                     value1 = checkBoolean(row[item.name]);
                                };
                                if(item.base642){
                                    value2 = row[item.name2] ? CFStringDecodeJP(row[item.name2],base64Swicth) : '';
                                }else{
                                    value2 = checkBoolean(row[item.name2]);
                                };

                                dataObject[item.name] = value2 ? value1 + ' ' + value2 : value1;
                            }else{
                                let value = row[item.name];
                                value = (value === null || value === undefined)  ? '' : value;
                                if(item.base64){
                                    if ( item.type === 'excelItem' ) {//excel出力用
                                            dataObject[item.name + 'Excel']  = value ? CFStringDecodeJP(value,base64Swicth): '';
                                        }
                                    else{
                                        dataObject[item.name] = value ?  CFStringDecodeJP(value,base64Swicth): '' ;
                                    }
                                }else{
                                    if(item.type === 'date'){
                                        dataObject[item.name] = CFUTCToDateInputFormatEdit(value);
                                    } else if ( item.type === Boolean ) {
                                        dataObject[item.name] = value;
                                    }else if ( item.type === 'excelItem' ) {//excel出力用
                                        dataObject[item.name + 'Excel']  = checkBoolean(value );
                                    } else {
                                        dataObject[item.name] = checkBoolean(value);
                                    }
    
                                };
                            }
                        }
                        
                        
                    });
                    dataObject.id = index;
                    /* データセット */
                    dataEdit.push(dataObject);
                });
                

                location?.state?.data?.forEach((obj, locationIndex) => {
                    const dataEditIndex = dataEdit.findIndex(data => data.id === obj.id)
                    if(dataEditIndex > 0){
                        dataEdit[dataEditIndex] = location.state.data[locationIndex]
                    };
                });
                
                /* フィルター項目があったらフィルターをかける */
                const filter = CFArrayFount(searchContentsRight,'type','inputVariableList');
    
                /* APIデータ格納用のstate更新 */
                if(filter){
                    const filterValue = getValues(`search.${filter.id}`);
                    if(filterValue){
                        const list = [];
                        dataEdit.forEach((row)=>{
                            if(row[filter.id] === filterValue.split(' ')[0]){
                                list.push(row)
                            }
                        });
                        if(list.length > 0){
                            /* APIデータ格納用のstate更新 */
                            setValue('payload',list)
                            setDisplayData(list);
                        }else{
                            setDataRow(list);
                            setValue('payload',list);
                            setDisplayData(list);
                        }
                    }else{
                        setDataRow(dataEdit);
                        setValue('payload',dataEdit);
                        setDisplayData();
                    }
                }else{
                    setDataRow(dataEdit);
                    setValue('payload',dataEdit);
                    setDisplayData();
                }



            }else{//APIリクエスト結果 = 異常

                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });

            };
            /* 画面表示開始 */
            setLoading(true);
        });

    };

    /* === 更新処理 === */
    const updateData = async() =>{
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト*/
        const handlingInformation = {};
        const key = [];
        const payload = [];

        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail;
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'UPDATE';

        confirm.data.forEach((cnf,i)=>{
            if(Object.keys(confirm.flags[i]).some(e =>confirm.flags[i][e] === true)){
                /* キーをセット */
                const keyObject = {};
                updateConfig.key.forEach((k)=>{
                    keyObject[k] = cnf[k];
                });
                /* ペイロードをセット */
                const payloadObject = {};
                updateConfig.payload.forEach((item)=>{
                    let value = cnf[`${item.name}New`] !== undefined ? cnf[`${item.name}New`]: cnf[item.name];
                    if(value === undefined || value === '' || value === '未入力'){
                        payloadObject[item.name] = null;
                    }else if(item.type === String){
                        const editValue = item.name2 ? value.split(' ')[0] : value;
                        if(item.base64){
                            payloadObject[item.name] = CFStringEncodeJP(editValue,base64Swicth);   
                        }else{
                            payloadObject[item.name] = editValue;
                        }
                    }else if(item.type === Number) {
                        payloadObject[item.name] = Number(value)
                    }else if(item.type === Boolean){
                        payloadObject[item.name] = value === 'true' ? true : value === 'false' ? false : value;
                    }
                    payloadObject.ctgr = 'update';
                });
                
                /* objectを格納 */
                key.push(keyObject);
                payload.push(payloadObject);
            };
        });
        const apiPath = updateApiPath;
        /* リクエストパラメータ */
        const apiBody = { handlingInformation: handlingInformation, key: key, payload: payload };
        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* プログレスバー非表示 */
            setProgress(false);

			/* APIリクエスト結果を判定 */
            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                navigate('/common/completion', {
                    state:{
                        title: `${CFArrayFount(screenIdList,'value',CFArrayFount(screenMaster,'path',location.pathname).id).label}編集完了`, 
                        message: screenDisplayMessage('CMNI004'), //データの更新が完了しました。
                        button:[
                            {name: '一覧画面へ戻る', path: location.pathname}
                        ]
                        },
                    replace:true
                 },);

            }else{//APIリクエスト結果 = 異常

                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    $1:result.responseData ? result.responseData.data.metadata: '',//取得件数
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });

            };
        });

    }
    /* === 確認ボタンを押した時の処理 === */
    const onClickConfirm = (data) =>{
        /* 変更データの編集　*/
        const oldData = [];
        const newData = [];
        // const checkString = (v) =>{
        //     if(v === undefined || v === null){
        //         return '';
        //     }else if(v === true){
        //         return 'true';
        //     }else if(v === false){
        //         return 'false';
        //     }else{
        //         return v;
        //     }
        // }
        data.payload.forEach((row)=>{
            const oldDataArray = CFArrayFount(displayData?displayData:dataRow,'id',row.id);
            const newDataArray = {...oldDataArray,...row};
            // console.log(oldDataArray,newDataArray)
            // updateConfig.payload.forEach((item)=>{
            //     if(item.name2){
            //         oldDataArray[item.name] = displayData ? displayData[index][item.name]:dataRow[index][item.name];
            //         newDataArray[item.name] = row[item.name];
            //         // .split(' ')[0];
            //         // newDataArray[item.name2] = row[item.name].substr(newDataArray[item.name].length + 1);
            //     }else{
            //         oldDataArray[item.name] = checkString(displayData ? displayData[index][item.name]:dataRow[index][item.name]);
            //         newDataArray[item.name] = checkString(row[item.name]);
            //     }
            // })
            oldData.push(oldDataArray)
            newData.push(newDataArray)
        });
        /* 変更点がない場合　*/
        if(CFJsonIgnore(oldData) === CFJsonIgnore(newData)){
            /* スナックバー表示 */
            setSnackbarMessage({      
                ...snackbarMessage,
                open:true,
                message:'CMNW004',
                type: 2,//APIエラー時:1,それ以外:2 
            });
        }else{
        /* 変更点がある場合　*/
            /* 確認モードに変更　*/
            setPageMode('confirm');
            
            /* keyの抽出 */
            const keys = Object.keys(dataRow[0]);
            /* 変更があればchangeFlagをtrueにする */
            let changeFlags = checkChangeFlag(oldData,newData, keys);
            setConfirm(
                {
                    flags:changeFlags,
                    data:confirmChange(changeFlags,oldData,newData, keys)
                }
            );
            /* 変更後データの格納 */
            setNewData(data.payload);
            /* ペイロードのリセット */
            setValue('payload',confirmChange(changeFlags,oldData,newData, keys));
        }
    }
   
    /* ===　キャンセル・戻るボタンを押した時の処理=== */
    const onClickLeft = () => {
        /* 編集モード時(キャンセルボタン押下時の処理) */
        if(pageMode === 'edit'){
            if(backButton){
                navigate(path);
            }else{
                /* 変更点のチェック */
                const oldData = [];
                const newData = [];
                getValues('payload').forEach((row,index)=>{
                    const oldDataArray = {};
                    const newDataArray = {};
                    updateConfig.payload.forEach((item)=>{
                    oldDataArray[item.name] = displayData ? displayData[index][item.name]:dataRow[index][item.name];
                    newDataArray[item.name] = row[item.name];
                    });
                    oldData.push(oldDataArray);
                    newData.push(newDataArray);
                });
    
                /* キャンセルした場合(OKボタン押下)の処理 */
                const afterCancel = () =>{
                    /* 値のリセット */
                    setValue('payload',newData);
                    setConfirm({});
                    /* 一覧表示に戻る　*/
                    setPageMode('list');
                    /* データ取得 */
                    getData();
                }
                /* データの変更がなければ、編集モードを終了 */
                if(CFJsonIgnore(oldData) === CFJsonIgnore(newData)){
                    afterCancel();
                }
                /* データの変更があれば、確認ダイアログを表示 */
                else{
                    /* 更新確認ダイアログ表示 */
                    setDialogMessage({      
                        ...dialogMessage,
                        open: true,
                        message: 'CMNC001',//メッセージID(commonFunctionより対象のメッセージ)
                        afterFunc:afterCancel,
                        pattern:2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
                    });
                }
            }
        }            
        /* 確認モード時(戻るボタン押下時の処理) */
        else{
            /* 編集モードに戻す */
            setPageMode('edit');
            /* 変更後データをpayloadにセット */
            setValue('payload',newData);
            /* stateを空にする */
            setConfirm({});
        }
        
    };
    /* ===　編集ボタン・確認ボタンを押した時の処理　=== */
    const onClickCenter = () => {
        switch(pageMode){
            // 一覧モード
            case 'list':
                if(displayData){
                    if(displayData.length > 0){
                        setPageMode('edit');
                    }
                }else{
                    if(dataRow.length > 0){
                        setPageMode('edit');
                    };
                }
                location.state = {};
                break;
            // 確認モード
            case 'confirm':
                updateData();
                break;
            // その他
            default :
                if(dataRow.length > 0){
                    setPageMode('edit')
                };
                location.state = {};
                break;
        };
    };
    /* === エクセル出力ボタン押下時の処理 === */
    const onClickExcel = (excelTitle,excelConfig) => {
        const afterFunc = async(row) =>{
            /* プログレスバー表示 */
            setProgress(true);
            /* リクエスト先 */
            const apiPathExcel = '/common/registeroutputrecord';
            /* リクエスト*/
            const handlingInformationExcel = {};
            const keyExcel = {};
            
            /* 操作情報 */
            handlingInformationExcel.hndEmpMailAdrs = userInfoValue.mail; 
            handlingInformationExcel.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
            handlingInformationExcel.sreId = screenId;
            handlingInformationExcel.hndId = 'GET';
            /* キー */
            keyExcel.dlFileId = screenId;
            keyExcel.dlCdt = [];
            /* 検索値の取得 */
            let searchData = getValues('search');

            Object.keys(searchData).forEach((sKey)=>{
                const object = {};
                object.sarCd = sKey;
                object.sarValue = searchData[sKey] ? CFStringEncodeJP(searchData[sKey],base64Swicth) : null;
                keyExcel.dlCdt.push(object);
            });
            /* リクエストパラメータ */
            const apiBodyExcel = {handlingInformation:handlingInformationExcel, key:keyExcel};

            await apiData.getDataPost(apiPathExcel, apiBodyExcel, (excelResult) => {
                /* プログレスバー非表示 */
                setProgress(false);
                if(excelResult.isSuccessed) {//APIリクエスト結果 = 正常
                    /* エクセル出力 */
                    CreateExcel(excelTitle,excelConfig,dataRow,codeDefinitionValue,master);

                }else{//APIリクエスト結果 = 異常
                    /* スナックバー表示 */
                    setSnackbarMessage({      
                        ...snackbarMessage,
                        open:true,
                        message:excelResult,//APIによるエラー
                        type: 1,//APIエラー時:1,それ以外:2 
                        level:'error',//エラースナックバー
                    })
                };
            });
	    }
        /* 更新確認ダイアログ表示 */
        setDialogMessage({      
            ...dialogMessage,
            open: true,
            message: 'CMNC002',//メッセージID(commonFunctionより対象のメッセージ)
            afterFunc:afterFunc,
            pattern:2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
        });
    }
    /* === 一括登録ボタン押下時の処理 === */
    const onClickBulkUpdate = (path) => {
        navigate(path);
    };

    /* === アンダーバーのタイプをチェック === */
    const checkUnderbarType = () =>{
        let type;
        switch(listType){
            case 'listEditable':
                if(pageMode === 'edit'){
                    type = 'confirmCancel' //確認ボタン、キャンセルボタンを表示
                }else if(pageMode === 'confirm'){
                    type = 'completeBack' //確認ボタン、戻るボタンを表示
                }else if(dataRow.length === 0){
                    type = '' //編集ボタンを表示
                }else{
                    type = 'edit' //編集ボタンを表示
                }
                break;
            default: 
                type = 'none'//ボタン表示なし
                break;
        };
        return type;
    };

    /* === タイトル名をチェック === */
    const checkTitle = (mode) =>{
        let title;
        switch(mode){
            case 'list':
                title = `${pageTitle}`;
            break;
            case 'edit':
                title = `${pageTitle}編集`;
            break;
            case 'confirm':
                title = `${pageTitle}確認`;
            break;
            default:
                title = `${pageTitle}`;
            break;
        }
        return title;
    }
    
    /* ====== 初期表示 ====== */ 
    useEffect(() => {
        if(masterList){
            /* 仕入先マスタの取得 */
            getMaster('',masterList);
        }else{
            createBodyData();
            getData();
        }
        if(searchValue?.[screenId]){
            setValue('search',searchValue[screenId])
        }else{
            setValue('search',defaultSearch);
        }
        /* APIデータ取得(initialSearchがtrueなら初期検索をかける) */
        // initialSearch && ();
        // eslint-disable-next-line
    },[]);

    const watchSarTrg = useWatch({control, name: 'search.sarTrg'})
    useEffect(() => {
        if(disableSelectBox){
            const sarTrg = getValues('search.sarTrg');
            if(sarTrg !== 'emoloyeeList'){
                setValue('search.sarYear', '');
                setValue('search.sarMonth', '');
            }
            disableSelectBox(getValues('search.sarTrg'));
        }
    },[disableSelectBox, getValues, setValue, watchSarTrg])
    
    /* ===== bodyDataを変更した時の処理 ===== */
    useEffect(()=>{
        createBodyData();
        // eslint-disable-next-line
    },[bodyData])

    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */

    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */
    /* ====== 画面表示開始前 ====== */
    if(!loading){
        return(
            <LoadingProgressBar open={progress}/>
        );
    };

    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */
    return(
        <>
            {/* プログレスバー */}
            <LoadingProgressBar open={progress}/>
            {/* 画面タイトル */}
            <CommonStyle.GdivTitleWrapper>
            <Title text={checkTitle(pageMode)} borderBottom='none'/>
            </CommonStyle.GdivTitleWrapper>
            <CommonStyle.GdivPageContentsWrapper>
                <form onSubmit={handleSubmit(getData)}>
                    {searchContentsLeft || searchContentsRight ?
                        // 検索欄
                        <SearchField
                        register={register}
                        payload='search'
                        payloadData={watch('search')}
                        search={searchContentsLeft}
                        search01={searchContentsRight}
                        reset={reset}
                        headCells={headData}
                        onClickExcel={onClickExcel}
                        onClickBulkUpdate={onClickBulkUpdate}
                        editMode={pageMode === 'edit' || pageMode === 'confirm'}
                        errors={errors}
                        setDisplayData={setDisplayData}
                        dataRow={dataRow}
                        defaultSearch={defaultSearch}
                        setValue={setValue}
                        />
                        :
                        ''
                    }
                </form>
                <form noValidate onSubmit={handleSubmit(onClickConfirm)}>
                    <Table
                        paperStyle={
                            listType === 'list' ?
                                { maxHeight: 'calc(100vh - 190px)' }
                            :searchContentsLeft || searchContentsRight ? 
                                { maxHeight: 'calc(100vh - 230px)' } 
                            :
                                { maxHeight: 'calc(100vh - 170px)' }
                        }//{ maxHeight: assets().size.tableHeightsize }
                        headCells={(pageMode === 'edit' && editHeadData) ? editHeadData : headData} //ヘッダの設定情報
                        bodyCells={pageMode === 'edit' ? editBodyDataNew : bodyDataNew} //ボディの設定情報
                        dataRow={pageMode === 'confirm' ? confirm.data : (displayData ? displayData : dataRow)} //表示データ
                        onClickBodyRow={onClickBodyRow}
                        errors={errors}
                        payload='payload'
                        register={register}
                        hoverEffect={true}
                        tableType={searchCount ? '' : 'edit'} //検索件数表示するかどうか
                        payloadData={getValues('payload')}
                        setValue={setValue}
                        editMode={pageMode === 'edit' || pageMode === 'confirm'}
                        changeFlags={confirm.flags}
                    />
                    {/* アンダーバー */}
                    {listType !== 'list' ? //編集しないタイプの一覧では表示しない
                        <Underbar
                            type={checkUnderbarType()} //react-hook-form
                            onClickLeft={()=>onClickLeft()}//キャンセル・戻るボタン押下時の処理
                            // onClickCenter={(event) => pageMode ? 1 : onClickEdit()}//編集ボタン押下時の処理
                            onClickCenter={()=>onClickCenter()}//編集ボタン・確認ボタン押下時の処理
                            mfzDisable={!getValues('payload')?.find(obj => obj.outputTarget === true)}
                        />
                    :<></>}
                </form>

            </CommonStyle.GdivPageContentsWrapper>
            <form onSubmit={handleSubmit(() => setDialogMessage({open: false}),  () => console.log(errors))}>
                {/* ダイアログ */}
                <Dialog
                    content={dialogMessage}
                    set={setDialogMessage}
                /> 
            </form>

            {/* スナックバー */}
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage}
            />
        </>
    );
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */ 


